export const createDataProperties = (properties: Array<Record<string, any>>) => properties.reduce(
    (allProperties, currentProperty) => ({...allProperties, ...currentProperty}), {},
);
